import Area from '@/components/Area';
import { OrbitControls, TransformControls, TransformControlsProps, useCursor } from '@react-three/drei';
import { Canvas, ThreeEvent } from '@react-three/fiber';
import { Leva, useControls } from 'leva';
import * as React from 'react';
import { create } from 'zustand';

type ObjectFromEvent = ThreeEvent<MouseEvent>['object'] | null;

type Store = {
  target: ObjectFromEvent;
  setTarget: (target: ObjectFromEvent) => void;
};

const useStore = create<Store>((set) => ({
  target: null,
  setTarget: (target) => set({ target }),
}));

function Box(props: React.ComponentProps<'mesh'>) {
  const { setTarget } = useStore();
  const [hovered, setHovered] = React.useState(false);
  useCursor(hovered);
  return (
    <mesh
      {...props}
      onClick={(e) => setTarget(e.object)}
      onPointerOver={() => setHovered(true)}
      onPointerOut={() => setHovered(false)}
    >
      <boxGeometry />
      <meshNormalMaterial />
    </mesh>
  );
}

export type Props = {};

type Controls = {
  mode: NonNullable<TransformControlsProps['mode']>;
};

function App01(props: Props) {
  const {} = props;
  const { target, setTarget } = useStore();
  const [{ mode }, set] = useControls(
    () => ({
      mode: {
        value: 'translate',
        options: ['translate', 'rotate', 'scale'],
      },
      position: { value: [0, 0, 0], step: 0.1 },
      rotation: { value: [0, 0, 0], step: 0.1 },
      scale: {
        value: [1, 1, 1],
        step: 0.1,
        lock: true,
        transient: false,
        onChange: (value, _name, info) => {
          if (target && !info.initial) {
            console.log('scale changed', info);
            // target.scale.set(...(set.get().scale as [number, number, number]));
            target.scale.set(...(value as [number, number, number]));
            target.updateMatrix();
          }
          return false;
        },
      },
    }),
    [target]
  );

  return (
    <>
      <Leva
        // // theme={myTheme} // you can pass a custom theme (see the styling section)
        // fill // default = false,  true makes the pane fill the parent dom node it's rendered in
        // flat // default = false,  true removes border radius and shadow
        // oneLineLabels // default = false, alternative layout for labels, with labels and fields on separate rows
        // hideTitleBar // default = false, hides the GUI header
        // collapsed // default = false, when true the GUI is collpased
        // hidden // default = false, when true the GUI is hidden
        hidden={target === null}
      />

      <Area>
        {() => (
          <Canvas
            //
            // dpr={[1, 2]}
            onPointerMissed={() => {
              setTarget(null);
            }}
          >
            <Box position={[2, 2, 0]} />
            <Box />
            {target && (
              <TransformControls
                object={target}
                mode={mode as Controls['mode']}
                onObjectChange={(e) => {
                  if (e) {
                    console.log({ mode, target });
                    set({
                      position: target.position.toArray(),
                      rotation: target.rotation.toArray() as [number, number, number],
                      scale: target.scale.toArray() as [number, number, number],
                    });
                  }
                }}
              />
            )}
            <OrbitControls makeDefault />
          </Canvas>
        )}
      </Area>
    </>
  );
}

export default React.memo(App01);
